import React from 'react';
import styles from './Container.module.css';
import ContainerHeader from './ContainerHeader/ContainerHeader';
import SearchForm from '../SearchForm/SearchForm';
import ContentBox from '../ContentBox/ContentBox';
import loader from '../../images/loader.gif';

export default class Container extends React.PureComponent {
	render() {
		const data = this.props.properties;
		const { type } = this.props;
		const { content } = data;

		const classes = `${styles.container} ${styles[type]}`;
		let classesPhoto = null;

		let searchForm = (
			<SearchForm
				id={data.SearchForm.id}
				icon={data.SearchForm.searchFormIcon}
				onInputChange={data.SearchForm.changeFilter}
			/>
		);

		const img = data.isLoading && <img src={loader} alt="" className={styles.loader} />;

		if (type === 'photos') {
			searchForm = null;
			classesPhoto = styles.photosInnerContainer;
		}

		return (
			<div className={classes} onClick={data.onContainerClick}>
				<ContainerHeader
					title={data.ContainerHeader.title}
					links={data.ContainerHeader.links}
				/>
				{searchForm}
				{img}
				<div className={classesPhoto}>
					{content.map((element, index) => {
						if(!element.id || typeof element.id !== 'string') return null;
						const elementId = element.id.replace(/-| /g, '_');
						const properties = { ...data, ...element };
						const droppableId = `${data.droppableId}-${elementId}`;
						let key = `${data.droppableId}-${elementId}`;

						if (type === 'photos') {
							key = `${data.droppableId}-${elementId}-${index}`;
						}

						return (
							<ContentBox
								index={index}
								showStudent={(id) => this.props.showStudent(id)}
								showTeacher={(id) => this.props.showTeacher(id)}
								properties={properties}
								type={type}
								droppableId={droppableId}
								key={key}
							/>
						);
					})}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Container/Container.js